// This file is for helpers that relate to any formatting of strings within the loading module

import * as R from 'ramda';

export const camelCaseToSentenceCase = R.compose(
  R.join(' '),
  R.adjust(0, str => str[0].toUpperCase() + str.substr(1)),
  R.split(' '),
  R.replace(/([A-Z])/g, ' $1')
);

export const sentenceToSnakeCase = R.compose(R.join('_'), R.split(' '), R.toLower);

export const formatFEIN = R.compose(R.join(''), R.insert(2, '-'));

export const pluralize = (count, noun, suffix = 's') => {
  return `${count} ${noun}${count !== 1 ? suffix : ''}`;
};
